"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishingWaitingTelemetry = void 0;
var PublishingWaitingTelemetry = /** @class */ (function () {
    function PublishingWaitingTelemetry(telemetry) {
        var _this = this;
        this.telemetry = telemetry;
        this.Open = function () { return _this.telemetry.send('Jumpstart_PublishingWaiting_Open'); };
        this.Close = function (openDuration) {
            _this.telemetry.send('Jumpstart_PublishingWaiting_Close', {
                OpenDuration: openDuration,
            });
        };
    }
    return PublishingWaitingTelemetry;
}());
exports.PublishingWaitingTelemetry = PublishingWaitingTelemetry;
//# sourceMappingURL=PublishingWaitingTelemetry.js.map